import { classNames } from "primereact/utils";
import { useState } from "react";
import {
  Link,
  useNavigate
} from "react-router-dom";
import ButtonZegel from "../../components/Buttons/ButtonZegel";
import "./styles/EvaluacionDashboard.scss";
import useAlumno from  "../../hooks/useAlumno";

const EvaluacionDashboard = ({ cursoUsuario, objUnidad, evaluacionUnidad, personaCurso }) => {
  const navigate = useNavigate();
  let { configuraciones } = useAlumno();
  const [objEvaluacionI1, setObjEvaluacionI1] = useState(
    evaluacionUnidad.find(
      (x) => x.idUnidad === objUnidad.idUnidad && x.intento == 1
    )
  );
  const [objEvaluacionI2, setObjEvaluacionI2] = useState(
    evaluacionUnidad.find(
      (x) => x.idUnidad === objUnidad.idUnidad && x.intento == 2
    )
  );
  return (
    <div className="dashboard-evaluacion">
      <div
        className="text-xl font-bold titulo-eva paddingTituloEvaluacion"
        style={{ marginBottom: 20 }}
      >
        Evaluación U{objUnidad.secuencia}
      </div>
      <div
        className="evaluacion-indicaciones"
        style={{ marginBottom: 20, padding: 20 }}
      >
        <div
          className="text-sm text-sm-mobile font-bold"
          style={{ marginBottom: 20 }}
        >
          Indicaciones
        </div>
        <div className="text-base text-sm-mobile">
        ¡Demuestra lo aprendido y comienza la evaluación! Tienes solo 2 intentos para rendirla y la mayor puntuación será tu nota de la unidad. Recuerda que para obtener el certificado del {cursoUsuario?.idPersonaPrograma !== null? "módulo":"curso"} deberás contar con un promedio final de al menos 13 puntos.
        </div>
      </div>
      <div
        className="flex gap-3 card-container-intentos"
        style={{ marginBottom: 40 }}
      >
        <div className="nota-intento">
          <div className="intento-info">Nota del primer intento</div>
          <div
            className={classNames("intento-nota", {
              "intento-aprobado": objEvaluacionI1 && objEvaluacionI1.nota >= configuraciones?.filter(z => z.codigo === "NOTA_MINIMA_APROB")[0].valor,
              "intento-desaprobado":
                objEvaluacionI1 && objEvaluacionI1.nota < configuraciones?.filter(z => z.codigo === "NOTA_MINIMA_APROB")[0].valor,
            })}
          >
            {objEvaluacionI1 ? objEvaluacionI1.nota : "-"}
          </div>
        </div>
        <div className="nota-intento">
          <div className="intento-info">Nota del segundo intento</div>
          <div
            className={classNames("intento-nota", {
              "intento-aprobado": objEvaluacionI2 && objEvaluacionI2.nota >= configuraciones?.filter(z => z.codigo === "NOTA_MINIMA_APROB")[0].valor,
              "intento-desaprobado":
                objEvaluacionI2 && objEvaluacionI2.nota < configuraciones?.filter(z => z.codigo === "NOTA_MINIMA_APROB")[0].valor,
            })}
          >
            {objEvaluacionI2 ? objEvaluacionI2.nota : "-"}
          </div>
        </div>
      </div>
      <div className="justify-content-start btn-comenzar-evaluacion botonInicioEvaluacion" >
        {!evaluacionUnidad.find((x) => x.idUnidad === objUnidad.idUnidad) ? (
          <Link
            to={
              "/Inicio/Evaluacion/Introduccion/" +
              personaCurso +
              "/1/" +
              objUnidad.idUnidad
            }
            style={{ width: "29%" }}
          >
            <ButtonZegel
              color={"primary"}
              label="Comenzar primer intento"
              width="100%"
            // onClick={() =>
            // navigate(
            //     "/Inicio/Evaluacion/Introduccion/-1/" + objUnidad.idUnidad
            // )
            // }
            />
          </Link>
        ) : !objEvaluacionI2 ? (
          <Link
            to={
              "/Inicio/Evaluacion/Introduccion/" +
              personaCurso +
              "/2/" +
              objEvaluacionI1.idUnidad
            }
            style={{ width: "29%" }}
          >
            <ButtonZegel
              color={"primary"}
              label="Comenzar segundo intento"
              width="100%"
            //   onClick={() =>
            //     navigate(
            //       "/Inicio/Evaluacion/Introduccion/" +
            //         objEvaluacionI1.idEvaluacion +
            //         "/" +
            //         objEvaluacionI1.idUnidad
            //     )
            //   }
            />
          </Link>
        ) : (
          <></>
        )}
      </div>
      {objEvaluacionI2 &&
        objEvaluacionI2.nota < 13 &&
        objEvaluacionI1 &&
        objEvaluacionI1.nota < 13 && (
          <div className="mt-5 text-center">
            <p className="font-bold">¡Lo sentimos!</p>
            <p>
            Desaprobaste ambos intentos, sin embargo, te animamos a seguir adelante. Recuerda que para obtener el certificado del {cursoUsuario?.idPersonaPrograma !== null ? "módulo" : "curso"} deberás contar con un promedio final de al menos 13 puntos.
            </p>
          </div>
        )}
    </div>
  );
};

export default EvaluacionDashboard;
